export function isLineFeed(char: string): boolean
{
  return char === '\n'
}